import { render, staticRenderFns } from "./alternatives.vue?vue&type=template&id=d372a196"
import script from "./alternatives.vue?vue&type=script&lang=js"
export * from "./alternatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports